import React, { useEffect } from 'react'

const INSCHRIJF_URL = "https://forms.gle/oetLKuGWTrXTvRBQ7";

function Inschrijven() {
  useEffect(() => {
    window.location.replace(INSCHRIJF_URL);
  }, []);

  return (
    <div class="container">
        <br/>
        <div class="row rowContent">
            <p class="text-zwart">
                Je wordt doorgestuurd naar het inschrijfformulier...
                Lukt dit niet? <a href={INSCHRIJF_URL}>Klik dan hier</a>.
            </p>
        </div>
    </div>
  )
}

export default Inschrijven
